// extracted by mini-css-extract-plugin
module.exports = {"root":"ModalCreateQualiphyProcedure_root__1upue","footer":"ModalCreateQualiphyProcedure_footer__1elb8","additionData":"ModalCreateQualiphyProcedure_additionData__2ExIY"};